module.exports = __webpack_public_path__ + "img/halal.fba8a062.svg";